import React from "react";
import { Modal } from "react-bootstrap";
import { cancelIcon } from "../../../../constant/imagePath";
import Colors from "../../../../stories/assets/Colors";
import classes from "./ModalSkeleton.module.css";

export default function ModalSkeleton({
  show,
  setShow,
  header,
  footer,
  children,
  modalClass,
  hideHeaderBorder,
  headerStyles,
  footerStyles,
  borderRadius,
  showCloseIcon,
  width,
}) {
  function handleClose() {
    setShow(false);
  }
  return (
    <>
      <style jsx>{`
        .modal-header {
          border-bottom: ${hideHeaderBorder
          ? "none"
          : `1px solid ${Colors.neutralShadesOfGainsboro}`};
        }
        .modal-footer {
          margin: 0px;
          display: unset;
          justify-content: unset;
          align-items: unset;
          padding: 0px;
        }

        .${classes.header} button {
          color: ${Colors.neutralShadesOfNero} !important;
          background: url(${cancelIcon}) !important;
        }
        .modal-content {
          width: 100%;
          border-radius: ${borderRadius ? borderRadius : "0px"};
        }
        .modal .modal-dialog {
          max-width: ${width};
          margin: 0px auto;
        }
        @media screen and (max-width: 480px) {
          .modal .modal-dialog {
            max-width: 90%;
          }
        }
      `}</style>

      <Modal
        show={show}
        onHide={handleClose}
        centered
        className={`${[classes.modal].join(" ")}`}
      >
        {header && (
          <Modal.Header
            closeButton
            className={`${[classes.header].join(" ")}`}
            style={{ ...headerStyles }}
          >
            <div>{header}</div>
          </Modal.Header>
        )}
        {showCloseIcon && (
          <div className={classes.iconBox} onClick={handleClose}>
            <img src={cancelIcon} />
          </div>
        )}
        <Modal.Body
          className={`${[classes.body, modalClass && modalClass].join(" ")}`}
        >
          {children}
        </Modal.Body>
        {footer && (
          <Modal.Footer
            className={`${[classes.footer].join(" ")}`}
            style={{
              borderTop: `1px solid ${Colors.neutralShadesOfGainsboro}`,
              ...footerStyles,
            }}
          >
            <div>{footer}</div>
          </Modal.Footer>
        )}
      </Modal>
    </>
  );
}
